import { waitForElement } from 'Base/shared/bk/modules/waitForElement';
import DomUtils from 'Base/modules/bk/bk-dom-utils';
import { dispatchStartLoadingEvent, dispatchStopLoadingEvent } from 'Base/modules/bk/events/bk-loading-animation';
import DataTable from 'datatables.net-dt';
import bkLoadBackendData from 'Base/modules/bk/bk-load-backend-data';
import BaseApi from 'Base/api/BaseApi';

window.bkmsWebApi = {
    waitForElement: waitForElement,
    ready: DomUtils.ready,
    dispatchStartLoadingEvent: dispatchStartLoadingEvent,
    dispatchStopLoadingEvent: dispatchStopLoadingEvent,
    DataTable: DataTable,
    getAccountUuid: async () => {
        const accountData = await bkLoadBackendData.getAccount();

        return accountData?.uuid;
    },
    BaseApi: BaseApi,
};
